// extracted by mini-css-extract-plugin
export var container = "styles-module--container--DTTAr";
export var copyright = "styles-module--copyright--CMhxd";
export var footer = "styles-module--footer--VXWlt";
export var navBar = "styles-module--navBar--dsrCt";
export var navWrapper = "styles-module--navWrapper--0jZbH";